import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from './pages/Home';
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Company from "./pages/Company";
import NotFound from "./pages/NotFound";
import ChatWidget from './components/ChatWidget';
import { LANGUAGES, localizePath } from './i18n';

const AdminRoutes = lazy(() => import('./pages/AdminRoutes'));
// The Bilgi Merkezi pages load on demand to keep the main bundle small
const ResourceHub = lazy(() => import('./pages/resources/ResourceHub'));
const LaserArticle = lazy(() => import('./pages/resources/LaserArticle'));
const VideoLibrary = lazy(() => import('./pages/resources/VideoLibrary'));
const DesignGuide = lazy(() => import('./pages/resources/DesignGuide'));
const Glossary = lazy(() => import('./pages/resources/Glossary'));
const Calculators = lazy(() => import('./pages/resources/Calculators'));
const Materials = lazy(() => import('./pages/resources/Materials'));
const BendingArticle = lazy(() => import('./pages/resources/BendingArticle'));
const WeldingArticle = lazy(() => import('./pages/resources/WeldingArticle'));
const CuttingComparison = lazy(() => import('./pages/resources/CuttingComparison'));

const PAGES = [
  { path: '/', element: <Home /> },
  { path: '/company', element: <Company /> },
  { path: '/research', element: <ResourceHub /> },
  { path: '/research/laser-cutting', element: <LaserArticle /> },
  { path: '/research/press-brake-bending', element: <BendingArticle /> },
  { path: '/research/welding', element: <WeldingArticle /> },
  { path: '/research/cutting-methods', element: <CuttingComparison /> },
  { path: '/research/videos', element: <VideoLibrary /> },
  { path: '/research/design-guide', element: <DesignGuide /> },
  { path: '/research/glossary', element: <Glossary /> },
  { path: '/research/calculators', element: <Calculators /> },
  { path: '/research/materials', element: <Materials /> },
  { path: '/services', element: <Services /> },
  { path: '/contact', element: <Contact /> },
];

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Turkish at the root, English under /en, German under /de */}
        {LANGUAGES.flatMap(({ code }) => PAGES.map(({ path, element }) => (
          <Route key={`${code}${path}`} path={localizePath(path, code)} element={<Suspense fallback={null}>{element}</Suspense>} />
        )))}
        <Route path="/admin/*" element={
          <Suspense fallback={null}>
            <AdminRoutes />
          </Suspense>
        } />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ChatWidget />
    </Router>
  );
}

export default App;
